import { AuthService } from './../../../../services/auth.service';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import Swal from 'sweetalert2';
import {User, UserParam} from '../../../../models/user.model';
import {IRole} from '../../../../models/role.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../../services/user.service';
import {RoleService} from '../../../../services/role.service';
import {IWallet} from "../../../../models/wallet.model";
import {environment} from "../../../../environments/environment";
import {CommerciauxService} from "../../../../services/commerciaux.service";
import { Location } from '@angular/common';
import {Shop} from "../../../../models/shop.model";
import {ServiceService} from "../../../../services/service.service";
import {ShopService} from "../../../../services/shop.service";
import {ProductService} from "../../../../services/product.service";
import {WalletService} from "../../../../services/wallet.service";
import { IProduct, Product } from '../../../../models/product.model';
import { NameValidator } from '../../validators/name.validator';
import { Category, ICategory } from '../../../../models/category.model';
import { CategoryService } from '../../../../services/category.service';
import { IProductType, ProductType } from '../../../../models/productType.model';
import { ICharacteristics } from '../../../../models/characteristics.model';
import {PostService} from '../../../../services/post.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Post} from '../../../../models/post.model';
import {IPostProduct, PostProduct} from '../../../../models/postProduct.model';
import { ITransaction } from '../../../../models/transaction.model';
declare const $: any;
@Component({
  selector: 'app-kahpoo-shop',
  templateUrl: './kahpoo-shop.component.html',
  styleUrls: ['./kahpoo-shop.component.scss']
})
export class KahpooShopComponent implements OnInit {

  isSeller = false;
  isKahpoo = false;
  @ViewChild('publication') publication: any | null;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  @ViewChild('closebutton2') closebutton2;
  photoProduit: string = "";
  validProductPhoto:any;
  // @ts-ignore
  currentShop: Shop = {};
  url_photo: String;
  // @ts-ignore
  currentUser: User = [];
  productQuantity:number = 0;
  walletCostumer: IWallet;
  walletSeller: IWallet;
  // @ts-ignore
  currentWallet: IWallet = [];
  isTrueName = false;
  categories:ICategory[]=[];
  categoryWithGiftCard:ICategory[] = [];
  characteristics:ICharacteristics[]=[];
  productTypes:IProductType[]=[];

  allProductPosted: any[] = [];
  product: Product = {};
  newpostproduct = new PostProduct();
  newPostProd: IPostProduct[] =[];

  constructor(private userService: UserService,
              private fb: FormBuilder,
              private router: Router,
              private shopService: ShopService,
              private serviceService: ServiceService,
              private postService: PostService,
              private productService: ProductService,
              private walletService: WalletService,
              private modalService: BsModalService,
              private categoryService: CategoryService,
              private activatedRoute: ActivatedRoute, private authService: AuthService, private location: Location) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadKahpooShop();
      this.loadCategory();
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  filterProductsByCategory(products: Product[], categoryName: string): Product[] {
    return products.filter((product) => product.category.name === categoryName);
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  saveQuantity=(val: any)=>{
    let index = parseInt(val.target.value);
    this.productQuantity = Number(index);
    return true;
  }

  seuilProd = 0;
  testSeuilProd=false;
  subProductFormDis=false;
  productFormDis=false;
  saveSeuil=(val: any)=>{
    let index = parseInt(val.target.value);
    this.seuilProd = Number(index);
    if(this.seuilProd > this.productQuantity){
      this.testSeuilProd = true;
      this.productFormDis = true;
    }else{
      this.testSeuilProd = false;
      this.productFormDis = false;
    }
  }

  loadCategory= () => {
    this.categoryService.query(0,200).subscribe((data :any)=>{
      data.content.forEach((element:any) => {
        this.categories.push(element);
      });
      // console.log("Liste des catégories...");
      // console.log(this.categories);
    })
  };

  loadSubCategory=(val: any)=>{
    let index = parseInt(val.target.value);
    this.productService.getProductCategorySubType(Number(index)).subscribe(
      data=>{
        this.productTypes = data;
        // console.log(this.productTypes)
      }
    )
  }



  selectCategorie(val: any):number{
    let index = val.target.value;
    this.productService.getProductSubtypeCharacteristic(index).subscribe(rs=>{
      // console.log("¤¤¤¤¤¤¤¤¤¤¤¤¤")
      // console.log(rs);
      this.characteristics = rs;
    })
    return index;
  }

  get getProduit() { return this.produitForm.controls; }

  produitForm = this.fb.group({
    name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
    category: new FormControl('', Validators.required),
    product_type: new FormControl('', Validators.required),
    quantity: new FormControl('', [Validators.required,NameValidator.checkOnlyNumberValidator, Validators.maxLength(7),Validators.pattern('^[1-9][0-9]*$')]),
    threshold: new FormControl('', [Validators.required,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
    price: new FormControl('',[Validators.required,Validators.minLength(3),Validators.maxLength(8),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  });

  private loadKahpooShop() {
    this.shopService.kahpooShop().subscribe(rs => {
      this.currentShop = rs;

      this.postService.getAllPostProductGiftCardByShopId(this.currentShop?.shopID).subscribe(data => {
        this.allProductPosted = data;

        //console.log(" this.allProductGiftCard",  this.allProductPosted)
      });

      //console.log("Current shop.....")
     // console.log(this.currentShop)
      this.isKahpoo = this.currentUser.kahpoo;
      this.serviceService.getIdServiceByShop(this.currentShop.id).subscribe(dt => {
        //console.log(dt);
        // @ts-ignore
        this.currentShop.services = dt.content;
      });
      this.productService.getIdProductByShop(this.currentShop.id).subscribe((products: any) => {
        //console.log(dt);
        // this.currentShop.products = dt;
        this.currentShop.products = this.filterProductsByCategory(products, "Carte cadeaux");

       // console.log(" this.currentShop.products ",  this.currentShop.products )
      });
      this.walletService.getUSerWallet(this.currentShop.sellerId.id).subscribe(rs => {
        //console.log(rs);
        // @ts-ignore
        const wlt: IWallet[] = rs;
        wlt.forEach(value => {
          if (value.type === 'CUSTOMER') {
            this.walletCostumer = value;  
            this.walletCostumer.transactions.sort((a: any, b: any) => {
              let aA : any = new Date(a.date)
              let bB : any = new Date(b.date)
                 return bB - aA;
             
           });
          }
          if (value.type === 'SELLER') {
            this.walletSeller = value;
            this.walletSeller.transactions.sort((a: any, b: any) => {
             let aA : any = new Date(a.date)
             let bB : any = new Date(b.date)
                return bB - aA;
            
          });
          }
        });
      });
    });
  }

  onViewWallet(wallet: IWallet) {
    this.currentWallet = wallet;
    //console.log("this.currentWallet", this.currentWallet)
  }

  disableButtonValider = false;
  onFormSubmit(){
    this.validProductPhoto = this.photoProduit;
    let newproduit= new Product();
    if(this.produitForm.valid && !this.isTrueName && !this.msg00){
      if(this.photoProduit != ''){
        this.disableButtonValider = true;

        newproduit.name=this.produitForm.controls['name'].value;
        newproduit.category=this.getCategory(this.produitForm.controls['category'].value);
        newproduit.quantity=this.produitForm.controls['quantity'].value;
        newproduit.threshold=this.produitForm.controls['threshold'].value;
        newproduit.price=this.produitForm.controls['price'].value;
        newproduit.product_type=this.getSubCategory(this.produitForm.controls['product_type'].value);
        newproduit.photo=this.photoProduit;
        newproduit.shop=this.currentShop;
        // console.log("newproduit-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_")
        // console.log(newproduit)
        this.productService.saveProduct(newproduit).subscribe( rs=>{
          this.produitForm.reset();
          this.disableButtonValider = false;
          this.reloadComponent();
          document.getElementById("btnCloseModalEditProduct")?.click();
          this.produitForm.reset();
          this.loadKahpooShop();
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Votre produit a été enregistré avec succès.',
            showConfirmButton: false,
            timer: 1500
          });
          }, error => {
            this.disableButtonValider = false;
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur d\'ajout <br>'+error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          });

      }else{
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Vous devez ajouter au minimum une photo pour votre produit.',
          showConfirmButton: false,
          timer: 4000
        });
        newproduit = new Product();
      }
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner les champs obligatoires s\'il vous plaît.',
        showConfirmButton: false,
        timer: 5000
      });
    }
  }

  getCategory(id:any) :Category {
    let category:Category = new Category();
    this.categories.forEach(element => {
      if(element.id == id) {
        category = element;
      }
    })
    return category;
  }

  getSubCategory(id:any) :IProductType {
    let product_type:ProductType = new ProductType();
    this.productTypes.forEach(element => {
      if(element.id == id) {
        product_type = element;
      }
    })
    return product_type;
  }

  // Only AlphaNumeric
  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }

  }

  /**
   * Rechercher si le vendeur a déjà un produit en ce nom
  */

  getIfProductNameExist(nameTampon?: any): boolean{
    let testName = nameTampon.target.value;
    var testbool = true;
    this.currentShop.products.forEach(element =>{
      if(testbool){
        if(element.name){
          if(element.name.toUpperCase() === testName.toUpperCase()){
            testbool = false;
            this.isTrueName = true;
          }else{
            this.isTrueName = false;
          }
        }
      }
    })
    return this.isTrueName;
  }


  readFile(event: any) {
    this.whenClickForChangeImage = true;
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      // console.log("file :"+file);
      const reader = new FileReader();
      reader.onload = (readEvent: any) => {
        // console.log("url"+readEvent.target.result);
        this.photoProduit= readEvent.target.result;
        this.validProductPhoto = this.photoProduit;
      };
      reader.readAsDataURL(file);
    }
  }

  currentProduct: Product;
  onViewProduct(prod: any) {
    this.productService.getIdProduct(prod.id).subscribe(product =>  {
      this.currentProduct = product;
      //console.log("Détails produit.....");
      //console.log(this.currentProduct);
    });
  }

  updatedProduct: Product;
  whenClickForChangeImage : boolean = false;
  editProduct(prod: Product){
    this.categoryService.query(0,200).subscribe((data :any)=>{
      data.content.forEach((element:any) => {
        this.categories.push(element);
      });
      // console.log("Liste des catégories...");
      // console.log(this.categories);
    })
    this.productService.getProductCategorySubType(Number(prod?.category?.id)).subscribe(
      data=>{
        this.productTypes = data;
      }
    )
    this.updatedProduct = prod;
    //console.log("Updated product")
    //console.log(this.updatedProduct)
    this.photoProduit = this.url_photo + prod.photo;
    this.produitForm.patchValue({
      id: prod.id,
      name: prod.name,
      category: prod.category.id,
      product_type: prod.product_type.id,
      quantity: prod.quantity,
      threshold: prod.threshold,
      price: prod.price
    })
  }

  onSubmitEditForm(): void {

    if(!this.msg00){
      let produit         = new Product();
      produit.id          = this.updatedProduct.id;
      produit.productID   = this.updatedProduct.productID;
      produit.available   = this.updatedProduct.available;
      produit.createdAt   = this.updatedProduct.createdAt;
      produit.product_type= undefined;

      produit.name        = this.produitForm.controls['name'].value;
      produit.price       = this.produitForm.controls['price'].value;
      produit.quantity    = this.produitForm.controls['quantity'].value;
      produit.threshold   = this.produitForm.controls['threshold'].value;
      produit.category    = this.getCategory(this.produitForm.controls['category'].value);
      produit.product_type= this.getSubCategory(this.produitForm.controls['product_type'].value);

      this.whenClickForChangeImage == false ?  produit.photo="" : produit.photo=this.photoProduit;

      produit.shop=this.updatedProduct.shop;

      // console.log("🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥 Produit Envoyé ! 🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥")
      // console.log(produit);
      this.productService.updateProduct(produit).subscribe(rs=>{
        this.close1();
        this.reloadComponent();
        this.produitForm.reset();
        this.whenClickForChangeImage = false;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Les informations de votre produit ont été modifiés avec succès.',
          showConfirmButton: false,
          timer: 3000
        });
      }, error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Une erreur est survenue sur l\'édition du produit ! <br>'+error.error.errorMessage,
          showConfirmButton: false,
          timer: 3000
        })
      });
    }
  }

  //ça permet d'actualiser le composant
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  deleteProduit(prod:IProduct){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce produit ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.productService.deleteKahpooProduct(prod).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre produit est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadKahpooShop();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 5500
            })
          }
        )
      }
    })

  }

  msg00!:string;
  test00=false;
  url00: any;
  selectFile00(event: any) {
    var mimeType = event.target.files[0].type;
    var sizeFile=event.target.files[0].size;
    if(!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg00 = 'Selectionner une photo';
    }
    // console.log("size!!!!!")
    // console.log(sizeFile)
    if(sizeFile<2000000){
      // console.log(mimeType);
      if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "";
          this.test00 = true;
          // alert(this.test)
          this.url00 = reader.result;
          this.photoProduit = this.url00;
          // console.log( this.url00);
        }
      }else{

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "Ce type de fichier n'est pas pris en compte.";
          this.url00 = reader.result;
          this.test00 = false;
        }
      }
    }else{
      // this.msg = "la taille de l'image est trop grande";
      var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "La taille de l'image est trop grande";
          this.url00 = reader.result;
          this.photoProduit = this.url00;
          this.test00 = false;
          // console.log( this.url00)
        }
    }
  }

  openFile()
  {
    $('#photo_produit').click();
  }

  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}

  publishProduct(p: Product) {
    let alreadyPublished = false;
    this.allProductPosted.forEach(pp => {
      if(p.productID === pp.postProducts[0].productID){
        alreadyPublished = true;
      }
      if(alreadyPublished){
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'Oups! cette carte cadeau a été déjà mise en annonce',
          showConfirmButton: false,
          timer: 5500
        });
        return;
      }
    });

    if(alreadyPublished === false){
        this.publication.show();
        this.product = p;
    }
  }

  postForm = this.fb.group({
    price: new FormControl('', [ Validators.required,Validators.minLength(3), Validators.maxLength(10), NameValidator.checkOnlyNumberValidator ]),
    description: new FormControl('',[Validators.minLength(10),Validators.maxLength(255)])
  });

  model = {
    description: ''
  };

  get post() { return this.postForm.controls; }

  onFormSubmitGiftCard(){

    if(this.postForm.valid){
      let newpost = new Post();
      newpost.title = this.product.name;
      newpost.description = this.postForm.controls['description'].value;
      newpost.vip = false;
      this.newpostproduct.price = this.postForm.controls['price'].value;
      this.newpostproduct.product = this.product;
      this.newPostProd.push(this.newpostproduct);
      newpost.postProducts = this.newPostProd;
      this.postService.savePost(newpost).subscribe( rs=>{
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Votre annonce est en attente de validation.',
          showConfirmButton: false,
          timer: 3500
        });
        this.clear();
      }, error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        })
      })
    }
  }

  clear()
  {
    this.postForm.patchValue({
      price: [],
      description: []
    });
    this.publication.hide();
    this.loadKahpooShop();
  }
}
